<template>
  <section class="world-background-green">
    <cards-roulette
      :options="options"
      :type="'program_beneficiaries'"
      :loop="false"
    />
  </section>
</template>

<script>
import ProgramBeneficiaries from '@/constants/program_beneficiaries.js'
import CardsRoulette from '@/components/on-board/CardsRoulette.vue'
import OnBoardStepMixin from '@/mixins/onBoardStepMixin.js'

export default {
  mixins: [OnBoardStepMixin],
  components: { CardsRoulette },
  data() {
    return {
      options: ProgramBeneficiaries
    }
  },
  mounted() {}
}
</script>
